/**
 * Local storage keys used throughout the application
 * Single source of truth for all localStorage key names
 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'tegrat_auth_token',
  USER: 'tegrat_user',
  REFRESH_TOKEN: 'tegrat_refresh_token',
  ACCESS_TOKEN: 'tegrat_access_token',
};
